import React from "react";
import { Link } from "react-router-dom";

interface BreadcrumbProps {
  category: { name: string; slug: string };
  productName: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ category, productName }) => {
  return (
    <nav className="px-4 py-2 mb-3.5 w-fit text-base bg-yellow-400 rounded-xl">
      <ol className="flex flex-wrap">
        <li><Link to="/">Home</Link></li>
        <li className="mx-1">&gt;</li>
        <li><Link to={`/catalog/${category.slug}`}>{category.name}</Link></li>
        <li className="mx-1">&gt;</li>
        <li className="font-bold">{productName}</li>
      </ol>
    </nav>
  );
};

export default Breadcrumb;
